import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Card from "shared/Card";
import TicketGroup from "Events/Components/TicketGroup";
import AddButton from "Events/Components/AddButton";
import { Modal } from "shared/Modal";
import Input from "shared/@forms/Input";
import Button from "shared/Button";
import styles from "./TicketingV2Form.module.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Loader from "shared/Loader";

export function TicketingV2Form({
  ticketSets,
  setTicketSets,
  homesitesGroups,
  clearSessionsTicketSet,
  pageMode,
  isLocal,
  isSummerConference,
  isPublished,
  isVirtual,
  eventName,
  marketingInfo,
  isLocal2,
}) {
  const [showAddTicketSetModal, setShowAddTicketSetModal] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState(false);
  const handleAddTicketSet = () => {
    if (
      ticketSets.filter(
        (ticketSet) =>
          (ticketSet.ticketSet?.saved || ticketSet.ticketSet?.value) == name
      )?.length > 0
    ) {
      setError(true);
    } else {
      setTicketSets(
        [
          ...ticketSets,
          {
            ticketSet: { saved: name },
            ticketSetType: { saved: "sub" },
            badges: { saved: [] },
            sort: { saved: ticketSets.length + 1 },
            tickets: [
              {
                commonItemId: { saved: null },
                name: { saved: name },
                price: { saved: null },
                creditsRequired: { saved: false },
                limitedToGroups: { saved: [] },
                acceptedCreditTypes: { saved: [] },
                purchaseStartDate: { saved: null },
                purchaseEndDate: { saved: null },
                linkedVirtualTicket: { saved: { ticketId: null, name: null } },
              },
            ],
          },
        ],
        true
      );
      setShowAddTicketSetModal(false);
      setName("");
      setError(false);
    }
  };
  const handleSetTicketSet = (updatedTicketSet) => {
    const updatedTicketSets = ticketSets.map((ticketSet) =>
      ticketSet.id === updatedTicketSet.id ? updatedTicketSet : ticketSet
    );
    setIsRemoving(false);
    if (!isRemoving) {
      setTicketSets(updatedTicketSets);
    } else {
      setIsRemoving(false);
    }
  };
  const handleRemoveTicketSet = async (setToRemove) => {
    setIsRemoving(true);
    const updatedTicketSets = ticketSets.filter(
      (ticketSet) => ticketSet.id !== setToRemove.id
    );
    setTicketSets(updatedTicketSets, false, setToRemove.ticketSet);
    // clearSessionsTicketSet(setToRemove.ticketSet);
  };
  const handleAddTicket = (ticketSetId, name, price, id) => {
    const updatedTicketSets = ticketSets.map((tktSet) =>
      tktSet.id === ticketSetId
        ? {
            ...tktSet,
            tickets: [
              ...tktSet.tickets,
              {
                commonItemId: null,
                cancelFeeItemId: null,
                name: null,
                price: null,
                creditsRequired: false,
                limitedToGroups: [],
                acceptedCreditTypes: [],
                purchaseStartDate: null,
                purchaseEndDate: null,
                linkedVirtualTicket: { saved: { ticketId: null, name: null } },
              },
            ],
          }
        : tktSet
    );
    setTicketSets(updatedTicketSets, true);
  };

  const handleOrderChange = (sourceIndex, destinationIndex) => {
    // console.log(sourceIndex, destinationIndex);
    if (sourceIndex === destinationIndex || destinationIndex == null) return;

    const ticketSetsClone = [...ticketSets];

    const filteredSets = ticketSetsClone
      .filter((ticketSet) => ticketSet.ticketSetType.saved === "sub")
      .sort((a, b) => a.sort.saved - b.sort.saved);

    const draggedItem = filteredSets[sourceIndex];
    filteredSets.splice(sourceIndex, 1);
    filteredSets.splice(destinationIndex, 0, draggedItem);

    const updatedTicketSets = ticketSetsClone.map((ticketSet) => {
      const indexInFiltered = filteredSets.findIndex(
        (fSet) => fSet.id === ticketSet.id
      );

      return indexInFiltered !== -1
        ? {
            ...ticketSet,
            sort: {
              ...ticketSet.sort,
              saved: indexInFiltered + 2,
            },
          }
        : ticketSet;
    });

    // updatedTicketSets.forEach((set) => console.log(set.ticketSet, set.sort));
    setTicketSets(updatedTicketSets, false);
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    handleOrderChange(source.index, destination.index);
  };

  if (pageMode === "view") {
    return (
      <Card>
        <section>
          <div className={styles.bold}>TICKETING</div>
          {ticketSets.map((ticketSet, index) => (
            <div key={ticketSet.id || index} className={styles.section}>
              <TicketGroup
                ticketSet={ticketSet}
                setTicketSet={() => {}}
                removeTicketSet={() => {}}
                isMajorV1={false}
                isV2={true}
                isLocalV2={isLocal}
                onAddTicket={() => {}}
                homesitesGroups={homesitesGroups}
                isPublished={true}
                isVirtual={isVirtual}
                eventName={eventName}
                marketingInfo={marketingInfo}
                pageMode="view"
                isLocal2={isLocal2}
              />
            </div>
          ))}
        </section>
      </Card>
    );
  }

  return (
    <Card
      children={
        <section>
          <div className={styles.bold}>Ticketing</div>
          <hr className={styles.hr} />
          <div className={styles.ticketGroup}>
            {ticketSets
              .filter(
                (ticketSet) =>
                  (ticketSet.ticketSetType.saved ??
                    ticketSet.ticketSetType.value) === "main"
              )
              .map((ticketSet, index) => (
                <TicketGroup
                  key={ticketSet.id}
                  ticketSet={ticketSet}
                  setTicketSet={(newData) => handleSetTicketSet(newData)}
                  removeTicketSet={() => handleRemoveTicketSet(ticketSet)}
                  isMajorV1={false}
                  isV2={true}
                  isLocalV2={isLocal}
                  onAddTicket={() => handleAddTicket(ticketSet.id)}
                  homesitesGroups={homesitesGroups}
                  isSummerConference={isSummerConference}
                  isPublished={isPublished}
                  isVirtual={isVirtual}
                  eventName={eventName}
                  marketingInfo={marketingInfo}
                  isLocal2={isLocal2}
                />
              ))}
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="ticketSets">
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={styles.ticketGroup}
                >
                  {ticketSets
                    .filter(
                      (ticketSet) =>
                        (ticketSet.ticketSetType.saved ??
                          ticketSet.ticketSetType.value) === "sub"
                    )
                    .sort((a, b) => {
                      const sortA = a.sort.saved ?? a.sort.value;
                      const sortB = b.sort.saved ?? b.sort.value;

                      return sortA - sortB;
                    })
                    .map((ticketSet, index) => (
                      <>
                        {!ticketSet.id ? (
                          <Loader />
                        ) : (
                          <>
                            <Draggable
                              key={ticketSet.id || index}
                              draggableId={ticketSet.id?.toString()}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <TicketGroup
                                    key={`ticketGroup-${ticketSet.id || index}`}
                                    ticketSet={ticketSet}
                                    setTicketSet={(newData) =>
                                      handleSetTicketSet(newData)
                                    }
                                    removeTicketSet={() =>
                                      handleRemoveTicketSet(ticketSet)
                                    }
                                    isMajorV1={false}
                                    isV2={true}
                                    isLocalV2={isLocal}
                                    onAddTicket={() =>
                                      handleAddTicket(ticketSet.id)
                                    }
                                    homesitesGroups={homesitesGroups}
                                    isPublished={isPublished}
                                    isVirtual={isVirtual}
                                    eventName={eventName}
                                    marketingInfo={marketingInfo}
                                    isLocal2={isLocal2}
                                  />
                                </div>
                              )}
                            </Draggable>
                          </>
                        )}
                      </>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {!isPublished && (
            <div
              className={styles.addBtn}
              onClick={() => setShowAddTicketSetModal(true)}
            >
              <AddButton description={"Add New Ticket Set"} color="#9AB5BB" />
            </div>
          )}

          <Modal
            title="Add Ticket Set"
            isOpen={showAddTicketSetModal}
            onClose={() => {
              setName("");
              setError(false);
              setShowAddTicketSetModal(false);
            }}
            children={
              <div className={styles.modal}>
                <div className={styles.description}>
                  Please write a name for the new Ticket Set
                </div>
                <div className={styles.inputItem}>
                  <Input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Ticket Set Name"
                  />
                  {error && (
                    <div className={styles.errorMsg}>
                      Input must be a Unique Ticket Set Name
                    </div>
                  )}
                </div>
                <div className={styles.addButtonContainer}>
                  <Button
                    className={styles.addButton}
                    children={"Create"}
                    onClick={() => handleAddTicketSet()}
                  />
                </div>
              </div>
            }
          />
        </section>
      }
    />
  );
}

TicketingV2Form.propTypes = {
  ticketSets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      available: PropTypes.number,
      setAvailable: PropTypes.func,
      limit: PropTypes.string,
      setLimit: PropTypes.shape({}),
      ticketsPer: PropTypes.string,
      setTicketsPer: PropTypes.shape({}),
      tickets: PropTypes.array,
      updateTickets: PropTypes.shape({}),
      eventStartDate: PropTypes.string,
    })
  ),
  setTicketGroups: PropTypes.func,
};
